import React from 'react';
import { ToastContainer } from 'react-toastify';

import AppRoutes from './components/AppRoutes';

import 'react-toastify/dist/ReactToastify.css';
import '../src/styles/CommonStyles.css';
import './App.css';

const App = (): React.ReactElement => {
  return (
    <div className="app-container">
      <AppRoutes />
      <ToastContainer
        position="top-center"
        hideProgressBar={true}
        closeButton={true}
      />
    </div>
  );
};

export default App;
